import React, { useState, useEffect } from "react";
import { Layout, Menu, Modal, Descriptions, Spin } from "antd";
import { Link } from "react-router-dom";
import { Table, Divider, Space } from "antd";

import { UserOutlined, EyeOutlined } from "@ant-design/icons";
import HealthBoardForm from "../../Components/healthboard/healthBoardForm.component";
import UpdateHealthBoard from "../../Components/healthboard/updateHealthBoard.component";
import "./healthboard.css";
import SiderComponent from "../../Components/Sider.component";

const { Header, Content } = Layout;

const HealthBoard = (props) => {
  const [reportsLoader, setReportsToggle] = useState(false);
  const [recordsLoader, setRecordsToggle] = useState(false);
  const [healthData, setHealthData] = useState([]);
  const [HealthRecords, setHealthBoardDataById] = useState([]);
  const [pid, setId] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const PatientId = props.match.params.id;

  const columns = [
    {
      title: "Article Date",
      dataIndex: "article_date",
      key: "article_date",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Written By",
      dataIndex: "written_by",
      key: "written_by",
    },
    {
      title: "action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <EyeOutlined
            title="See Records"
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => {
              getHealthBoardDataById(record.hb_id);
              setRecordsToggle(false);
              showModal();
            }}
          />

          <UpdateHealthBoard
            hb_id={record.other_data_two}
            title={record.title}
            article_date={record.article_date}
            description={record.description}
            written_by={record.written_by}
            url={record.url}
            other_data_one={record.other_data_one}
            fetchHealthBoardData={fetchHealthBoardData}
          />
        </Space>
      ),
    },
  ];

  useEffect(() => {
    fetchHealthBoardData();
    setId(PatientId);
  }, []);

  const fetchHealthBoardData = () => {
    const url = `https://app02.thbglobal.com/v1/healthBoard`;

    fetch(url, {
      headers: {
        "x-api-key": `Bearer ${JSON.parse(localStorage.getItem("tokens"))}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.type === "Success") {
          setHealthData(result.data);
          setReportsToggle(true);
        } else {
          setReportsToggle(true);
        }
      });
  };

  const getHealthBoardDataById = (hb_id) => {
    const url = `https://app02.thbglobal.com/v1/healthBoard/${hb_id}`;

    fetch(url, {
      headers: {
        "x-api-key": `Bearer ${JSON.parse(localStorage.getItem("tokens"))}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.type === "Success") {
          setHealthBoardDataById(result.data);
          setRecordsToggle(true);
        } else {
          setRecordsToggle(true);
        }
      });
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="health-board">
      <Layout className="layout">
        <Header>
          <Menu theme="dark" mode="horizontal">
            <Menu.Item key="1" icon={<UserOutlined />}>
              <Link to="/dashboard">Back to Dashboard</Link>
            </Menu.Item>
          </Menu>
        </Header>
        <Layout hasSider="true">
          <SiderComponent selectedKey="6" />
          <Content style={{ padding: "0 50px", marginTop: "20px" }}>
            <div className="appointments-container">
              <div className="page-title">
                <h1>Health Board</h1>
              </div>
              <HealthBoardForm
                id={pid}
                fetchHealthBoardData={fetchHealthBoardData}
              />
            </div>
            <div className="site-layout-content">
              <span> Health Details</span>
              <Divider />
              {reportsLoader ? (
                <Table
                  dataSource={healthData}
                  columns={columns}
                  rowKey={healthData.other_data_two}
                  pagination={{ position: ["bottomCenter"] }}
                />
              ) : (
                <Spin
                  size="large"
                  style={{ position: "absolute", top: "50%", left: "50%" }}
                />
              )}
              {/* <h1 style={{ marginLeft: "10px" }}>Select Patient</h1>*/}

              <Modal
                title="Details"
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                width={800}
              >
                {recordsLoader ? (
                  <Descriptions
                    bordered
                    title="Health Board"
                    size="large"
                    column={1}
                    labelStyle={{ backgroundColor: "#dad2d2", width: "125px" }}
                  >
                    <Descriptions.Item label="Article Date">
                      {HealthRecords.article_date}
                    </Descriptions.Item>
                    <Descriptions.Item label="Title">
                      {HealthRecords.title}
                    </Descriptions.Item>
                    <Descriptions.Item label="Category">
                      {HealthRecords.other_data_one}
                    </Descriptions.Item>

                    <Descriptions.Item label="URL">
                      {HealthRecords.url}
                    </Descriptions.Item>
                    <Descriptions.Item label="Written By">
                      {HealthRecords.written_by}
                    </Descriptions.Item>
                    <Descriptions.Item label="Description">
                      {HealthRecords.description}
                    </Descriptions.Item>
                    {HealthRecords?.picture && (
                      <Descriptions.Item label="Picture">
                        {
                          <a
                            type="primary"
                            size="small"
                            href={`${HealthRecords?.picture}`}
                            target="_blank"
                          >
                            Download to View
                          </a>
                        }
                      </Descriptions.Item>
                    )}
                  </Descriptions>
                ) : (
                  <Spin
                    size="large"
                    style={{ position: "absolute", top: "50%", left: "50%" }}
                  />
                )}
              </Modal>
            </div>
          </Content>
          {/* <Footer style={{ textAlign: "right" }}>
        </Footer>
    */}
        </Layout>
      </Layout>
    </div>
  );
};
export default HealthBoard;
